import { render, staticRenderFns } from "./OrderIndex.vue?vue&type=template&id=131cc09a&"
import script from "./OrderIndex.vue?vue&type=script&lang=js&"
export * from "./OrderIndex.vue?vue&type=script&lang=js&"
import style0 from "./OrderIndex.vue?vue&type=style&index=0&id=131cc09a&prod&lang=css&"
import style1 from "./OrderIndex.vue?vue&type=style&index=1&id=131cc09a&prod&lang=scss&"
import style2 from "./OrderIndex.vue?vue&type=style&index=2&id=131cc09a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports